module.exports = tvg.deps.react['react-18'];